<template>
    <div>
        <div class="flex flex--directionColumn">
            <ul class="flex flex--spacing20">
                <li
                    v-for="(news, index) in pagedItems"
                    :key="index"
                    class="flex flex__item flex-s--justifyContent-center width33">
                    <a :href="`/news/${ news.uri }/${ news.locale }`">
                        <div class="margin-top-20 newsCard panelBox panelBox--hover panelBox--noPadding bg-white border-radius">
                            <img
                                v-if="isDev"
                                :src="news.headerPicture ?
                                    getCdnLink(`NewsFeedCMSDev/${ news.headerPicture }`, 'cms') :
                                    getCdnLink('img/news/news-archive.png')"
                                :alt="news.headline"
                                class="" />
                            <img
                                v-else
                                :src="news.headerPicture ?
                                    getCdnLink(`NewsFeedCMS/${ news.headerPicture }`, 'cms') :
                                    getCdnLink('img/news/news-archive.png')"
                                :alt="news.headline"
                                class="" />
                            <div class="padding-all-20">
                                <div class="text-color--gray-blue margin-bottom-20">
                                    {{ getLocalizedDate(news.tstampPublished) }}
                                </div>
                                <div class="newsCard__title">
                                    {{ news.headline }}
                                </div>
                            </div>
                        </div>
                    </a>
                </li>
            </ul>
        </div>
        <div class="newsPagination">
            <button
                type="button"
                rel="prev"
                :aria-label="trans('PREVIOUS_PAGE')"
                :disabled="currentPage === 1"
                class="newsPagination__button"
                @click="previousPage">
                <i
                    aria-hidden="true"
                    class="fa fa-angle-left">
                </i>
            </button>
            <span class="newsPagination__currentPage">
                {{ currentPage }}
            </span>
            <span class="newsPagination__separator">
                ⁄
            </span>
            <span class="newsPagination__page">
                {{ totalPages }}
            </span>
            <button
                type="button"
                rel="next"
                :aria-label="trans('NEXT_PAGE')"
                :disabled="currentPage === totalPages"
                class="newsPagination__button"
                @click="nextPage">
                <i
                    aria-hidden="true"
                    class="fa fa-angle-right">
                </i>
            </button>
        </div>
    </div>
</template>

<script>
    import { getCdnLink } from 'tools/getCdnLink';
    import Translator from 'tools/trans';

    export default {
        props: {
            items: { type: Array, required: true },
            search: { type: String, default: '' },
            itemsPerPage: { type: Number, default: 2 },
            locales: { type: Array, default: () => [] },
            initPage: { type: Number, default: 1 },
        },
        data() {
            return {
                isDev: window.stGlobals.env === 'dev',
                itemsPerPageData: this.itemsPerPage,
                currentPage: this.initPage > 0 ? this.initPage : 1,
            };
        },
        computed: {
            filteredItems() {
                // filter by locale
                let filteredItems = this.items.filter(item => {
                    return this.locales.includes(item.locale);
                });
                // filter by search term
                filteredItems = filteredItems.filter(item => this.filterBySearch(item));

                return filteredItems;
            },
            totalPages() {
                const totalPages = Math.ceil(this.filteredItems.length / this.itemsPerPageData);

                return (totalPages === 0) ? 1 : totalPages;
            },
            pagedItems() {
                return this.filteredItems.filter((item, index) => {
                    const start = (this.currentPage-1) * parseInt(this.itemsPerPageData);
                    const end = this.currentPage * parseInt(this.itemsPerPageData);

                    return index >= start && index < end;
                });
            },
        },
        watch: {
            search() {
                this.resetPage();
            },
            currentPage() {
                this.$emit('input', this.currentPage);
            },
        },
        methods: {
            trans: Translator.trans,
            getCdnLink,
            filterBySearch(item) {
                const cleanedItem = this.cleanValue(item.headline);
                const cleanedSearch = this.cleanValue(this.search);
                if (cleanedItem.indexOf(cleanedSearch) > -1) {
                    return item;
                }
            },
            cleanValue(stringValue) {
                if (stringValue === null) {
                    return '';
                }

                return String(stringValue).replace(/\s/g, '').toLowerCase();
            },
            nextPage() {
                if (this.currentPage < this.totalPages) {
                    this.currentPage++;
                }
            },
            previousPage() {
                if (this.currentPage > 1) {
                    this.currentPage--;
                }
            },
            resetPage() {
                this.currentPage = 1;
            },
            getLocalizedDate(date) {
                const locale = window.stGlobals.locale;

                return new Date(date * 1000).toLocaleDateString(locale);
            },
        },
    };
</script>

